import React, {Component, PropTypes} from 'react';
import {
  Button,
  Col, ControlLabel,
  Form, FormControl, FormGroup, Icon, InputGroup,
  Modal,
} from '@sketchpixy/rubix';
import styled from 'styled-components';
import {ClipLoader} from 'react-spinners';
import {css} from 'react-emotion';

import {StyledFormGroup} from "../../payment/FromStyle";
import NumberFormat from "react-number-format";

import {
  savePayment
} from '../../../api/api';


import DatePicker from "react-datepicker";

const override = css`
  margin: auto 8px auto auto;
`;

const ButtonText = styled.div`
  display: flex;
`;

const Container = styled.div`
  display: flex;
  flex-flow: column;
  border-bottom: ${props => props.expand ? '2px' : '1px'} solid #d8d8d8;

`;

const Title = styled.div`
  height: 65px;
  font-weight: bold;
  color: black;
  display: flex;
  align-items: center;
`;

const Item = styled.div`
  display: flex;
  min-height: 60px;
  text-align: justify;
   
  &:last-child {
    border-bottom: 0;
  }
  
  & div:first-child {
    color: black;
  }
  
  & div {
    margin-top: auto;
    margin-bottom: auto;
    padding: 0;
  }
`;

const ItemTitle = styled.div`
  width: 202px;
`;

class AddPaymentModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      amount: {
        formattedValue: '',
        value: null,
      },
      tax: {
        formattedValue: '',
        value: null,
      },
      paymentDate: null,
      description: '',
      loading: false,
    };
  }

  componentDidMount() {
  }

  componentWillReceiveProps(nextProps) {
    this.state = {
      amount: {
        formattedValue: '',
        value: null,
      },
      tax: {
        formattedValue: '',
        value: null,
      },
      paymentDate: null,
      loading: false,
    };
  }


  displayAmount = (amount) => {
    const scientificNotation = Math.pow(10, this.props.decimalScale * -1);
    return (amount * scientificNotation).toFixed(2);
  };

  amountChangeHandler = (values) => {
    let amount = this.state.amount;

    const {formattedValue, value} = values;

    amount.formattedValue = formattedValue;
    amount.value = value * 100;

    this.setState({
      amount
    });
  };


  taxChangeHandler = (values) => {
    let tax = this.state.tax;

    const {formattedValue, value} = values;

    tax.formattedValue = formattedValue;
    tax.value = value * 100;

    this.setState({
      tax
    });
  };

  descriptionChangeHandler = (e) => {
    this.setState({
      description: e.target.value,
    });
  };

  paymentDateChangeHandler = (paymentDate) => {
    this.setState({
      paymentDate: paymentDate.getTime()
    });
  };

  getPaymentDate = () => {
    return this.state.paymentDate;
  };


  savePayment = () =>
  {
    this.setState({
      loading: true,
    });

    savePayment({
      contractId: this.props.contract.contractId,
      paymentDate: this.state.paymentDate,
      amount: this.state.amount.value,
      tax: this.state.tax.value,
      description: this.state.description,
    }, (err, result) => {
      this.setState({
        loading: false,
      });

      if (err) {
        Messenger().post({
          type: 'error',
          message: `${err.message} (${err.statusCode})`
        });
      } else {
        if (result.statusCode === "0" || result.statusCode === 0) {
          Messenger().post({
            type: 'success',
            message: 'successfully added!',
            showCloseButton: true,
          });
          this.props.paymentAdded();
        } else {
          Messenger().post({
            type: 'error',
            message: `Failed to Add Payment`
          });
        }
      }
    });
  };

  render() {
    let amountInputFormatProps = {
      className: 'form-control',
      thousandSeparator: true,
      decimalScale: 2,
      fixedDecimalScale: true,
      allowNegative: false,
    };

    return (
        <Modal
            show={this.props.showModal}
            onHide={this.props.closeModal}
            backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>Add Payment</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{height: '300px'}}>
            <Form horizontal>
            <StyledFormGroup>
              <Col xs={9}>
                <Container>
                  <Item>
                    <ItemTitle>Payment Date</ItemTitle>
                    <FormGroup>
                      <InputGroup>
                        <DatePicker
                            selected={this.getPaymentDate()}
                            onChange={(date) => this.paymentDateChangeHandler(date)}
                            withPortal
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"/>
                      </InputGroup>
                    </FormGroup>
                  </Item>
                  <Item>
                    <ItemTitle>Amount</ItemTitle>
                    <FormGroup>
                      <InputGroup>
                        <InputGroup.Addon>{this.props.contract.currencyString}</InputGroup.Addon>
                        <NumberFormat
                            {...amountInputFormatProps}
                            value={this.state.amount.formattedValue}
                            onValueChange={(values) => this.amountChangeHandler(values)}
                        />
                      </InputGroup>
                    </FormGroup>
                  </Item>
                  <Item>
                    <ItemTitle>Tax</ItemTitle>
                    <FormGroup>
                      <InputGroup>
                        <InputGroup.Addon>{this.props.contract.currencyString}</InputGroup.Addon>
                        <NumberFormat
                            {...amountInputFormatProps}
                            value={this.state.tax.formattedValue}
                            onValueChange={(values) => this.taxChangeHandler(values)}
                        />
                      </InputGroup>
                    </FormGroup>
                  </Item>
                  <Item>
                    <ItemTitle>Description</ItemTitle>
                    <FormGroup>
                      <InputGroup>
                        <FormControl
                            type='text'
                            placeholder='Description'
                            value={this.state.description ? this.state.description : ''}
                            onChange={this.descriptionChangeHandler}
                        />
                      </InputGroup>
                    </FormGroup>
                  </Item>
                </Container>
              </Col>
            </StyledFormGroup>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.props.closeModal}>Cancel</Button>
            <Button bsStyle="brownishgray" onClick={this.savePayment} disabled={this.state.loading}>
              <ButtonText>
                <ClipLoader
                    className={override}
                    sizeUnit={'px'}
                    size={12}
                    color={'#123abc'}
                    loading={this.state.loading}
                />
                <span>
                  Save
                </span>
              </ButtonText>
            </Button>
          </Modal.Footer>
        </Modal>
    );
  }
}

AddPaymentModal.propTypes = {
  paymentAdded: PropTypes.func.isRequired,
  contract: PropTypes.object.isRequired,
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default AddPaymentModal;



// WEBPACK FOOTER //
// ./src/routes/patient/PaymentHistory/AddPaymentModal.js